/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import {
    fetchSchoolDetailsSuccess,
    fetchContactDetailsSuccess,
    fetchSalesForceDetailsSuccess,
    fetchCreatorDetailsSuccess,
    searchSchoolByPostalCodeSuccess,
    clearSchoolDetail
} from "../_actions/order.details.actions";
import api from './api.services';
import axios from 'axios';
import {getCollectionById} from "./collection.thunk";
import {fetchApiDataFailure} from "../_actions/common.actions";
import {showMessage} from "../_actions/message.actions";

export const getSchoolDetails = (collectionId, onRequestClose = null) => dispatch => {
    axios.get(api.get_school_details.replace('{collection-id}',collectionId))
        .then(response => {
            dispatch(fetchSchoolDetailsSuccess(response.data));
            // used for institution change modal.
            if(onRequestClose){
                onRequestClose();
            }
        })
        .catch(error => {
            dispatch(clearSchoolDetail());
            console.log(error);
        });
};

export const getContactDetails = (collectionId) => dispatch => {
    axios.get(api.get_contact_details.replace('{collection-id}',collectionId))
        .then(response => {
            dispatch(fetchContactDetailsSuccess(response.data));
        })
        .catch(error => {
            console.log(error);
        });
};

export const getSalesForceDetails = () => dispatch => {
    axios.get(api.get_sales_force_org_details)
        .then(response => {
            dispatch(fetchSalesForceDetailsSuccess(response.data));
        })
        .catch(error => {
            console.log(error);
        });
};

export const getCreatorDetails = (creatorId) => dispatch => {
    axios.get(api.get_creator_details.replace('{creator-id}', creatorId))
        .then(response => {
            dispatch(fetchCreatorDetailsSuccess(response.data));
        })
        .catch(error => {
            console.log(error);
        });
};

export const updateSalesForceOrgUnit = (collectionId) => (dispatch, getState) => {
    axios.post(api.update_salesforce_org.replace('{collection-id}', collectionId).replace('{orgUnit}', getState().orderDetails.school.salesForceOrg))
        .then(response => {
            dispatch(getSchoolDetails(collectionId));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });
};

export const searchSchoolByPostalCode = (countryCode, postalCode, options) => dispatch => {
    return axios.get(api.search_school_by_postalcode.replace('{country-code}', countryCode).replace('{postal-code}', postalCode).concat('&isNccerCollection=').concat(options.isNccerCollection))
        .then(response => {
            dispatch(searchSchoolByPostalCodeSuccess(response.data));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });

};

export const saveSelectedSchool = (collectionId, schoolId, postalCodeSearchString, territoryId, onRequestClose) => ( dispatch, getState )=> {
    const institutionToBeStored = {'institution': schoolId, 'institutionZip': postalCodeSearchString, 'territory': territoryId};
    axios.patch(api.save_course_contacts_and_book_build_content.replace('{collection-id}', collectionId), institutionToBeStored)
        .then(response => {
            dispatch(getSchoolDetails(collectionId, onRequestClose));
            dispatch(showMessage({messageKey: 'institution_save_success', type: 'success' }));
            dispatch(updateOrganizationId(collectionId));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
            dispatch(showMessage({messageKey: 'institution_save_failed', type: 'error' }));
        });
};

export const updateOrganizationId = (collectionId) => ( dispatch, getState ) => {
    if(getState().etextStatuses.COURSE_CREATION.includes("SUCCESS")){
        axios.put(api.update_course_orgid.replace('{collection-id}', collectionId))
            .then(response => {
            })
            .catch(error => {
                console.log('Error',error);
            });
    }
};



// WEBPACK FOOTER //
// ./src/_thunks/order.details.thunk.js